import React, {useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/hooks';
import { getVisibleTypeTabs } from './tabs';

export default function TypesPage() {
    const navigate = useNavigate();
    const profile = useAppSelector(store => store.profile);

    useEffect(() => {
        const availableTab = getVisibleTypeTabs(profile)[0];
        if (availableTab) {
            navigate(availableTab.path, { replace: true });
        }
    }, [navigate, profile]);

    return <></>; {/*This form cannot be deleted. This intermediate form is needed to ensure that the breadcrumbs display correctly.*/}
};
